import { Controller } from "stimulus"
import { showTarget, hideTarget } from '../../helpers/visibility'

export default class extends Controller {
  static targets = [
    "paymentMethodSelector",
    "discountCodeWrapper",
    "adjustBasedOnSelector",
    "flatRateWrapper",
    "percentWrapper",
  ]

  connect() {
    this.updateVisibility()
  }

  updateVisibility() {
    const paymentSelectorValue = this.paymentMethodSelectorTarget.value
    const adjustBasedOnSelectorValue = this.adjustBasedOnSelectorTargets.find(radio => radio.checked)?.value

    if(paymentSelectorValue === "coupon_code") {
      showTarget(this.discountCodeWrapperTarget)
    }
    else {
      hideTarget(this.discountCodeWrapperTarget)
    }

    if(adjustBasedOnSelectorValue === "flat_rate") {
      showTarget(this.flatRateWrapperTarget)
      hideTarget(this.percentWrapperTarget)
    }
    else {
      hideTarget(this.flatRateWrapperTarget)
      showTarget(this.percentWrapperTarget)
    }
  }
}
